"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatType = void 0;

var Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));

var Button_1 = __importDefault(require("@material-ui/core/Button"));

var Card_1 = __importDefault(require("@material-ui/core/Card"));

var CardActions_1 = __importDefault(require("@material-ui/core/CardActions"));

var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));

var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var List_1 = __importDefault(require("@material-ui/core/List"));

var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));

var ListItemAvatar_1 = __importDefault(require("@material-ui/core/ListItemAvatar"));

var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var react_1 = __importDefault(require("react"));

var react_countup_1 = __importDefault(require("react-countup"));

var ai_1 = require("react-icons/ai");

var constants_1 = require("../../constants");

var icon_1 = require("../StoriesAPI/Story/utils/icon");

var useStyles_1 = __importDefault(require("./useStyles"));

var StatType;

(function (StatType) {
  StatType["list"] = "list";
  StatType["number"] = "number";
  StatType["string"] = "string";
})(StatType = exports.StatType || (exports.StatType = {}));

var countDecimals = function countDecimals(value) {
  if (Math.floor(value) === value) return 0;
  return value.toString().split('.')[1].length || 0;
};

var StatListItemAvatar = function StatListItemAvatar(_a) {
  var className = _a.className,
      label = _a.label,
      icon = _a.icon;

  if (icon && icon.source === constants_1.IconSource.Image) {
    return react_1.default.createElement(Avatar_1.default, {
      alt: label,
      className: className,
      src: icon.url
    });
  }

  return react_1.default.createElement(Avatar_1.default, {
    className: className
  }, icon ? (0, icon_1.buildIcon)(icon) : label[0].toUpperCase());
};

var StatValue = function StatValue(_a) {
  var classes = _a.classes,
      type = _a.type,
      value = _a.value;
  var isArray = Array.isArray(value);

  if (type === StatType.number && _typeof(value) === 'object' && !isArray) {
    var _b = value,
        amount = _b.amount,
        unit = _b.unit;
    return react_1.default.createElement("div", {
      className: classes.numberContainer
    }, react_1.default.createElement(Typography_1.default, {
      className: classes.number,
      variant: "h3"
    }, react_1.default.createElement(react_countup_1.default, {
      decimals: countDecimals(amount),
      delay: 0.5,
      duration: Math.random() * 3,
      end: amount
    })), unit && react_1.default.createElement(Typography_1.default, {
      className: classes.unit,
      color: "textSecondary",
      variant: "body2"
    }, unit));
  }

  var isList = type === StatType.list && isArray;

  var avatarCtrClass = function avatarCtrClass(index) {
    var base = classes.listAvatarContainer;

    if (isList && index === value.length - 1) {
      return base + " last-item";
    }

    return base;
  };

  return isList ? react_1.default.createElement(List_1.default, {
    className: classes.list
  }, value.map(function (_a, index) {
    var description = _a.description,
        icon = _a.icon,
        label = _a.label;
    return react_1.default.createElement(ListItem_1.default, {
      alignItems: "flex-start",
      className: classes.listItem,
      key: label
    }, react_1.default.createElement(ListItemAvatar_1.default, {
      className: avatarCtrClass(index)
    }, react_1.default.createElement(StatListItemAvatar, {
      className: classes.listAvatar,
      icon: icon,
      label: label
    })), react_1.default.createElement(ListItemText_1.default, {
      primary: label,
      secondary: description
    }));
  })) : react_1.default.createElement("div", {
    className: classes.string
  }, value);
};

var Stat = function Stat(_a) {
  var color = _a.color,
      description = _a.description,
      iconData = _a.icon,
      image = _a.image,
      label = _a.label,
      type = _a.type,
      url = _a.url,
      value = _a.value;
  var icon = iconData && (0, icon_1.buildIcon)(iconData);
  var classes = (0, useStyles_1.default)({
    accentColor: color.background
  });
  var hasAdditionalData = !!(image || description || url);
  return react_1.default.createElement(Card_1.default, {
    className: classes.root,
    raised: true
  }, icon && react_1.default.createElement("div", {
    className: classes.icon
  }, icon), react_1.default.createElement("div", {
    className: classes.labelContainer
  }, react_1.default.createElement(Typography_1.default, {
    className: classes.label,
    variant: "overline"
  }, label)), react_1.default.createElement(CardContent_1.default, {
    className: classes.content
  }, react_1.default.createElement(StatValue, {
    classes: classes,
    type: type,
    value: value
  }), hasAdditionalData && react_1.default.createElement(Divider_1.default, {
    variant: "middle"
  }), image && react_1.default.createElement(CardMedia_1.default, {
    component: "img",
    image: image,
    title: label
  }), react_1.default.createElement(Typography_1.default, {
    color: "textSecondary",
    variant: "caption"
  }, description)), react_1.default.createElement(CardActions_1.default, {
    className: classes.actions
  }, url && react_1.default.createElement(Button_1.default, {
    className: classes.button,
    color: "primary",
    href: url,
    size: "small",
    target: "_blank",
    startIcon: react_1.default.createElement(ai_1.AiOutlineInfoCircle, null),
    variant: "text"
  }, "Learn More")));
};

exports.default = Stat;